import { Component } from '@angular/core';

@Component({
  selector: 'app-counterparties',
  templateUrl: './counterparties.component.html',
  styleUrls: ['./counterparties.component.sass']
})
export class CounterpartiesComponent {

}
